import React from "react"
import { Card, CardBody, Row, Col, Spinner } from "reactstrap"
import { useSelector } from "react-redux"
import PrimaryButton from "newcomponents/primary-button"
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined"
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined"
import WavingHandOutlinedIcon from "@mui/icons-material/WavingHandOutlined"
import StarBorderOutlinedIcon from "@mui/icons-material/StarBorderOutlined"
import AddIcon from "@mui/icons-material/Add" // ✅ NEW ICON IMPORT

const Miniwidget = ({ reports = [], loading, viewMode, setViewMode }) => {
  const mode = useSelector(state => state.Layout.layoutMode)

  // 🔹 Icon Map
  const iconMap = {
    group: <GroupOutlinedIcon style={{ fontSize: 26 }} />,
    like: <ThumbUpOutlinedIcon style={{ fontSize: 26 }} />,
    wave: <WavingHandOutlinedIcon style={{ fontSize: 26 }} />,
    star: <StarBorderOutlinedIcon style={{ fontSize: 26 }} />,
  }

  // 🔹 Dynamic column sizing
  const getColSize = count => {
    if (count === 1) return 12
    if (count === 2) return 6
    if (count === 3) return 4
    return 3
  }
  const colSize = getColSize(reports.length)

  return (
    <React.Fragment>
      {/* 🔹 Header Section */}
      <div
        style={{
          backgroundColor: mode === "dark" ? "#252f40" : "#fff",
          borderRadius: "16px",
          boxShadow:
            mode === "dark"
              ? "0px 2px 6px rgba(0,0,0,0.5)"
              : "0px 2px 6px rgba(0,0,0,0.1)",
          padding: "24px",
          marginBottom: "24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
        }}
      >
        {/* Left: Title + Connected Button */}
        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
          <h1
            style={{
              margin: 0,
              fontSize: "28px",
              fontWeight: "600",
              color: mode === "dark" ? "#fff" : "#111827",
            }}
          >
            Instagram
          </h1>

          <PrimaryButton
            onClick={() => {
              window.location.href = `/dashboard/integrations`
            }}
            style={{
              padding: "6px 14px",
              fontSize: "13px",
              fontWeight: "500",
              borderRadius: "6px",
              border: "1.5px solid #2990DF",
              backgroundColor: "transparent",
              color: "#2990DF",
              textTransform: "uppercase",
            }}
          >
            Connected
          </PrimaryButton>
        </div>

        {/* Right: Create Post + View Mode */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            flexWrap: "wrap",
          }}
        >
          {/* View Mode Buttons */}
          <div
            style={{
              display: "flex",
              gap: "10px",
              backgroundColor: mode === "dark" ? "#1f2937" : "#F9FAFB",
              border:
                mode === "dark" ? "1px solid #374151" : "1px solid #E5E7EB",
              borderRadius: "8px",
              padding: "6px",
            }}
          >
            <PrimaryButton
              onClick={() => setViewMode("Month")}
              style={{
                padding: "8px 16px",
                fontSize: "14px",
                borderRadius: "6px",
                backgroundColor:
                  viewMode === "Month"
                    ? "#2990DF"
                    : mode === "dark"
                      ? "#1f2937"
                      : "#F9FAFB",
                color:
                  viewMode === "Month"
                    ? "#fff"
                    : mode === "dark"
                      ? "#9CA3AF"
                      : "#111827",
                border: "none",
              }}
            >
              Month
            </PrimaryButton>

            <PrimaryButton
              onClick={() => setViewMode("Week")}
              style={{
                padding: "8px 16px",
                fontSize: "14px",
                borderRadius: "6px",
                backgroundColor:
                  viewMode === "Week"
                    ? "#2990DF"
                    : mode === "dark"
                      ? "#1f2937"
                      : "#F9FAFB",
                color:
                  viewMode === "Week"
                    ? "#fff"
                    : mode === "dark"
                      ? "#9CA3AF"
                      : "#111827",
                border: "none",
              }}
            >
              Week
            </PrimaryButton>
          </div>
          {/* ✅ Create New Post Button */}
          <PrimaryButton
            onClick={() => {
              window.location.href = "/dashboard/instagram/create-post"
            }}
            style={{
              padding: "12px 28px",
              fontSize: "16px",
              fontWeight: "500",
              borderRadius: "8px",
            }}
          >
            Create New Post
            <AddIcon style={{ }} />
          </PrimaryButton>
        </div>
      </div>

      {/* 🔹 Report Cards */}
      <Row>
        {reports.map((report, key) => (
          <Col key={key} xl={colSize} lg={colSize} md={6} sm={12}>
            <Card
              style={{
                cursor: "default",
                border: "none",
                borderRadius: "16px",
                backgroundColor: mode === "dark" ? "#252f40" : "#fff",
                boxShadow:
                  mode === "dark"
                    ? "0px 2px 6px rgba(0,0,0,0.5)"
                    : "0px 2px 6px rgba(0,0,0,0.1)",
                transition: "all 0.3s ease",
                marginBottom: "20px",
              }}
            >
              <CardBody
                className="d-flex align-items-center justify-content-between"
                style={{ padding: "36px 24px" }}
              >
                <div>
                  <h6
                    style={{
                      color: mode === "dark" ? "#9CA3AF" : "#6B7280",
                      marginBottom: "4px",
                      fontSize: "14px",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                    }}
                  >
                    {report.title}
                  </h6>
                  <h4
                    style={{
                      color: mode === "dark" ? "#fff" : "#111",
                      margin: 0,
                      fontWeight: 600,
                      fontSize: "22px",
                    }}
                  >
                    {loading ? (
                      <Spinner
                        size="sm"
                        color={mode === "dark" ? "light" : "dark"}
                      />
                    ) : (
                      report.total
                    )}
                  </h4>
                </div>

                {/* Right Side Icon */}
                <div
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: mode === "dark" ? "#363F4F" : "#F1F1F1",
                    color: "#2990DF",
                  }}
                >
                  {iconMap[report.iconClass] || (
                    <GroupOutlinedIcon style={{ fontSize: 26 }} />
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </React.Fragment>
  )
}

export default Miniwidget
